import { Service, inject } from '@angular/core'
import {
  GetNotificationsResponse,
  GetUnreadNotificationsResponse,
  NotificationsBulkBody,
  NotificationsBulkResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class NotificationApiService {
  private readonly api = inject(ApiService)

  /** The caller's notifications, newest first, capped; filtered and paged in the browser. */
  getNotifications(init?: RequestInit) {
    return this.api.protectedFetchJson<GetNotificationsResponse>(`notifications`, { ...init })
  }

  getUnread(init?: RequestInit) {
    return this.api.protectedFetchJson<GetUnreadNotificationsResponse>(`notifications/unread`, { ...init })
  }

  bulk(body: NotificationsBulkBody, init?: RequestInit) {
    return this.api.protectedFetchJson<NotificationsBulkResponse>(`notifications/bulk`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }

  readAll(init?: RequestInit) {
    return this.api.protectedFetchJson<NotificationsBulkResponse>(`notifications/read-all`, {
      method: 'POST',
      ...init,
    })
  }
}
